const getDefaultState = () => {
  return {
    breadList: [{ // 面包屑导航
      name: '首页',
      path: '/'
    }],
    newsLabelList: [],
    storageHeaderName:'',
  }
}

const state = getDefaultState();

const mutations = {
  breadListAdd(state, obj) {
    // console.log('vuex——breadListAdd',obj);
    let length = state.breadList.length
    // if (obj.name != state.breadList[length - 1].name) {
    state.breadList.push(obj);
    // }
  },
  breadListRemove(state, num) {
    // console.log('vuex——breadListRemove',num);
    state.breadList = state.breadList.slice(0, num);
  },
  breadPageNameChange(state, name) {
    let length = state.breadList.length
    // console.log('vuex——breadPageNameChange',state.breadList);
    state.breadList[length - 1].name = name;
    if (name.length > 22) {
      state.breadList[length - 1].name = `${name.slice(0, 22)}...`
    }
  },
  setNewsLabel(state, res) {
    state.newsLabelList = res;
  },
  //替换路由数组第一个元素
  replace(state, res){
    // console.log('我是vuex里的替换前',state.breadList);
    state.breadList.splice(0, 1, res)
    // console.log('我是vuex里的替换后',state.breadList);
  },
  storageHeader(state, res){
    state.storageHeaderName = res;
  }
}

export default {
  state,
  mutations
};
